// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    .vega-container {
      width: 100%;
      min-height: 200px;
    }
    :host ::ng-deep .vega-embed {
      width: 100%;
    }
    :host ::ng-deep .vega-embed .chart-wrapper {
      width: 100%;
    }
  `, "",{"version":3,"sources":["webpack://./src/app/components/vega-chart/vega-chart.component.ts"],"names":[],"mappings":";IACI;MACE,WAAW;MACX,iBAAiB;IACnB;IACA;MACE,WAAW;IACb;IACA;MACE,WAAW;IACb","sourcesContent":["\n    .vega-container {\n      width: 100%;\n      min-height: 200px;\n    }\n    :host ::ng-deep .vega-embed {\n      width: 100%;\n    }\n    :host ::ng-deep .vega-embed .chart-wrapper {\n      width: 100%;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
